<div class="d-flex flex-column mx-5 my-2">
    <div class="row my-2" style="height: 60px;">
        <div class="col-12 d-flex align-items-center mb-3" style="font-size: 26px; font-weight: 600;">
            <button type="button" class="icon-btn mb-1" (click)="backToLanding()">
                <svg class="icon-16">
                    <use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use>
                </svg>
            </button>
            <span cvLocalizedText langSection="Templates" langKey="Templates">Templates</span>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col" style="min-height: 32px; margin-right: 370px;">
            <div class="d-flex flex-nowrap justify-content-between align-items-center">
                <div class="d-flex">
                    <button type="button" class="btn btn-primary mr-2"
                        [disabled]="useLoading"
                        [hidden]="!dashboardService.selectedSystemTemplate?.SystemTemplateKey && !dashboardService.selectedTemplate?.DashboardKey"
                        (click)="useTemplate()"
                    >
                        <span cvLocalizedText langSection="Templates" langKey="Use">Use</span>
                    </button>
                    <button type="button" class="btn btn-text btn-icon fill-cerulean"
                        [hidden]="!systemTemplateCrudAccess || !dashboardService.selectedSystemTemplate?.SystemTemplateKey"
                        (click)="removeTemplate()"
                    >
                        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
                        <span cvLocalizedText langSection="Common" langKey="Delete">Delete</span>
                    </button>
                </div>
                <div class="search-box live-search" style="width: 248px">
                    <input class="form-control form-control-lg form-control-gray" type="search" autocomplete="off"
                        [(ngModel)]="filterValue" (ngModelChangeDebounced)="onFilterChange()"
                        cvLocalizedPlaceholder langSection="Common" langKey="Search" placeholder="Search" placeholder="Search"
                    />
                    <span class="clear-input" [hidden]="!filterValue.length" (click)="filterValue = ''"></span>
                </div>
            </div>
        </div>
    </div>

    <div class="row" style="flex: 1 1 0px; min-height: 0px;">
        <div class="col mr-2 position-relative">
            <div class="position-relative" style="height: 200px" *ngIf="(!hasLoaded && (templatesLoading || systemTemplatesLoading)) || useLoading">
                <cv-loader [size]="'large'"></cv-loader>
            </div>
            <div class="card" *ngIf="noTemplates && hasLoaded">
                <div class="h-100 w-100 p-2 color-valyrianSteel d-flex flex-column align-items-center justify-content-center font-size-18"
                    cvLocalizedText langSection="Templates" langKey="No_Templates_Available">
                    No Templates Available
                </div>
            </div>
            <div class="h-100 w-100" [hidden]="useLoading || !hasLoaded || noTemplates">
                <ngb-accordion class="template-group-accordion" #acc="ngbAccordion" [destroyOnHide]="false">
                    <ngb-panel id="system-template-panel" *ngIf="systemTemplates.length > 0">
                        <ng-template ngbPanelHeader let-opened="opened">
                            <button ngbPanelToggle class="d-flex border-0 w-100 template-accordion-toggle">
                                <div><svg class="icon-24 fill-valyrianSteel oet-folder-icon">
                                    <use href="../App_Themes/clearview-default/icons/utility/folder.svg#folder"></use>
                                </svg><span cvLocalizedText langSection="Templates" langKey="SystemTemplates">System Templates</span></div>
                                <svg class="icon-16 fill-theUpsideDown ml-auto" [class.d-none]="opened"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg>
                                <svg class="icon-16 fill-theUpsideDown ml-auto" [class.d-none]="!opened"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg>
                            </button>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            <ag-grid-angular
                                #systemTemplateGrid
                                class="ag-theme-balham template-ag-grid"
                                [style.height]="getSystemHeight()"
                                [gridOptions]="gridOptionsSystem"
                                [rowData]="systemTemplates"
                            ></ag-grid-angular>
                        </ng-template>
                    </ngb-panel>
                    <ngb-panel id="shared-template-panel" *ngIf="templates.length > 0">
                        <ng-template ngbPanelHeader let-opened="opened">
                            <button ngbPanelToggle class="d-flex border-0 w-100 template-accordion-toggle">
                                <div><svg class="icon-24 fill-valyrianSteel oet-folder-icon">
                                    <use href="../App_Themes/clearview-default/icons/utility/folder.svg#folder"></use>
                                </svg><span cvLocalizedText langSection="Templates" langKey="SharedTemplates">Shared Templates</span></div>
                                <svg class="icon-16 fill-theUpsideDown ml-auto" [class.d-none]="opened"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg>
                                <svg class="icon-16 fill-theUpsideDown ml-auto" [class.d-none]="!opened"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg>
                            </button>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            <ag-grid-angular
                                #sharedGrid
                                class="ag-theme-balham template-ag-grid"
                                [style.height]="getSharedHeight()"
                                [gridOptions]="gridOptionsShared"
                                [rowData]="templates"
                            ></ag-grid-angular>
                        </ng-template>
                    </ngb-panel>
                </ngb-accordion>
            </div>
        </div>

        <div class="col card p-4 " style="max-width: 360px; height: calc(60vh + 50px)">
            <cv-selected-dashboard-details
                class="d-block h-100 position-relative"
                [enableEdit]="false"
                [selectedSharedTemplate]="dashboardService.selectedTemplate"
                [selectedSystemTemplate]="dashboardService.selectedSystemTemplate"
                [useTemplateCopy]="true"
                [hasTemplateAdminAccess]="systemTemplateCrudAccess"
            ></cv-selected-dashboard-details>
        </div>
    </div>
</div>
